export { FolioFisico, QrCargaMensaje } from "app/features/componentes/cargas"; 


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/lector/folioFisico.tsx